import React, { useState } from 'react';
import {
  Card,
  CardContent as CardBody,
  CardHeader,
} from '@shadcn/components/ui/card';


import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@shadcn/components/ui/dropdown-menu';


import '../datatables.scss';

import useQuery from '../../../helpers/JIFI/useQuery';

import { useHistory } from 'react-router-dom';
import superagent from 'superagent';
import { backendUrl } from '../../../helpers/consts.js';

import useProductData from '../orders/useProductData';
import SupplyChainNav from '../../../components/supply-chain/nav.js';
import ContainerTimelineView from '../../../components/supply-chain/container-timeline-view.js';
import CommentHostory from '../../Skote/Dashboard/CommentHistory.js';
import { Col } from '@shadcn/components/ui/col';
import { Badge } from '@shadcn/components/ui/badge';
// The team plans in days, so never render a time.
const fmtDate = (d) => {
  const date = d ? new Date(d) : null;
  return date && !isNaN(date) ? date.toDateString() : '—';
};

// Which rung of the backend's ETA precedence supplied the displayed date.
const etaSourceLabels = {
  manual: 'set manually',
  'warehouse-actual': 'received',
  'warehouse-booking': 'booking',
  vizion: 'estimate',
  existing: 'unconfirmed',
  none: 'unconfirmed',
};

const SummaryRow = ({ label, children }) => (
  <>
    <dt className="text-muted-foreground">{label}</dt>
    <dd className="font-medium mb-0">{children || '—'}</dd>
  </>
);

const StatusToBadge = ({ status }) => {
  const conversion = {
    draft: 'secondary',
    packing: 'secondary',
    'in-transit': 'warning',
    'at-port': 'warning',
    ready: 'success',
    completed: 'success',
    cancelled: 'succedangerss',
  };
  return (
    <Badge
      className={'font-size-12 badge-soft-' + conversion[status]}
      color={conversion[status]}
      pill
    >
      <i className={'fab ' + ' font-size-12 badge-soft-primary'}></i>{' '}
      {status?.replace('-', ' ')?.toUpperCase()}
    </Badge>
  );
};

const ASNToBadge = ({ ASNSent }) => {
  const color = ASNSent === false ? 'warning' : 'success';
  const text = ASNSent === false ? 'ASN NOT SENT' : 'ASN SENT';

  return (
    <Badge className={'font-size-12 badge-soft-' + color} color={color} pill>
      <i className={'fab ' + ' font-size-12 badge-soft-primary'}></i>{' '}
      {text.toUpperCase()}
    </Badge>
  );
};

const PullPage = ({ match: { params }, google }) => {
  const { containerID } = params;

  const history = useHistory();
  const [refresh, setRefresh] = useState(true);
  const [stockPull, setStockPull] = useState([]);

  const [replenishHistory, setReplenishHistory] = useQuery({
    url: `/inventory/fetchContainer/${containerID}`,
    refresh,
  });
  const container = replenishHistory;
  const getVariant = useProductData();
  const volumes = {};

  // COGS is only ever recalculated on demand — nothing recomputes it when a container
  // is received — so landed costs go stale after editing freight/local or line costs.
  const [recomputeState, setRecomputeState] = useState('idle');
  const handleRecomputeCogs = () => {
    setRecomputeState('loading');
    superagent
      .post(`${backendUrl}/cogs/recompute/${containerID}`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .then((response) => {
        const { costs = 0, rates = 0 } = response.body || {};
        // costs === 0 means the engine skipped it — usually an unresolvable region.
        setRecomputeState(costs > 0 ? `${costs} lines, ${rates} rates` : 'nothing to compute');
      })
      .catch((err) => {
        setRecomputeState(`failed (${err?.status || 'error'})`);
      });
  };

  const handelSendASN = () => {
    superagent
      .post(`${backendUrl}/inventory/convertContainerToASN/${containerID}`)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status;
        history.replace(history.location.pathname, {
          errorStatusCode: code,
        });
      })
      .then((response) => {
        const code = response.status;
        if (code > 400) {
          history.replace(history.location.pathname, {
            errorStatusCode: code,
          });
        } else {
          history.go(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <SupplyChainNav
      commentComponent={
        <CommentHostory
          maxHeight="30vh"
          title="Comments"
          initCommentType={'Container'}
          initOrderName={container?.name}
        />
      }
    >
      <div>
        <Col className="w-full">
          <Card>
            {container && (
              <>
                <CardHeader>
                  <h3 className="text-[24px] font-medium flex gap-2 flex-wrap items-center">
                    Invoice Ref: {container.name}
                    <DropdownMenu>
                      <DropdownMenuTrigger>
                        <i className="mdi mdi-dots-horizontal font-size-18"></i>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent>
                        <DropdownMenuItem
                          onClick={() => {
                            history.push(`/container/edit/${containerID}`);
                          }}
                        >
                          Edit
                        </DropdownMenuItem>


                        <DropdownMenuItem
                          onClick={handelSendASN}
                        >
                          Send ASN to {container.landingLocation.name}{' '}
                        </DropdownMenuItem>

                        <DropdownMenuItem
                          onClick={handleRecomputeCogs}
                          disabled={recomputeState === 'loading'}
                        >
                          {recomputeState === 'idle'
                            ? 'Recalculate COGS'
                            : recomputeState === 'loading'
                            ? 'Recalculating COGS…'
                            : `Recalculate COGS — ${recomputeState}`}
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                    {/* <UncontrolledDropdown
                      style={{ display: 'inline-block', padding: '0 16px' }}
                    >
                      <DropdownToggle href="#" className="card-drop" tag="i">
                        <i className="mdi mdi-dots-horizontal font-size-18"></i>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={() => {}}
                          href={`/container/edit/${containerID}`}
                        >
                          {' '}
                          Edit{' '}
                        </DropdownItem>
                        {container.ASNSent === false && (
                          <DropdownItem onClick={handelSendASN}>
                            {' '}
                            Send ASN to {container.landingLocation.name}{' '}
                          </DropdownItem>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown> */}
                    <StatusToBadge status={container.status} />
                    <ASNToBadge ASNSent={container.ASNSent} />
                  </h3>
                  <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 mt-2 mb-0 text-[13px]">
                    <SummaryRow label="Container ref">{container.ref}</SummaryRow>
                    <SummaryRow label="Warehouse">
                      {container.landingLocation?.display_name ||
                        container.landingLocation?.name}
                    </SummaryRow>
                    <SummaryRow label="Warehouse date">
                      {fmtDate(container.arrivalDate)}
                      {container.etaSource && (
                        <span className="text-muted-foreground">
                          {' '}
                          · {etaSourceLabels[container.etaSource] ?? container.etaSource}
                          {container.etaSource === 'manual' && container.etaManualOverrideBy
                            ? ` by ${container.etaManualOverrideBy}`
                            : ''}
                        </span>
                      )}
                      {/* Past its date with no arrival scan — the reason the number looks wrong. */}
                      {container.calculatedETA?.overdue && (
                        <Badge className="badge-soft-warning font-size-12 ml-2">
                          Running late
                        </Badge>
                      )}
                    </SummaryRow>
                    <SummaryRow label="Shipping carrier">
                      {container.shippingCarrier}
                    </SummaryRow>
                    {/* Untracked containers have no estimate; an empty row is just noise. */}
                    {container.vizionEta && (
                      <SummaryRow label="Estimate">
                        {fmtDate(container.vizionEta)}
                        {/* The band is the honest uncertainty; the single date stays the headline. */}
                        {container.vizionEtaRangeStart && container.vizionEtaRangeEnd && (
                          <span className="text-muted-foreground">
                            {' '}
                            ({fmtDate(container.vizionEtaRangeStart)} –{' '}
                            {fmtDate(container.vizionEtaRangeEnd)})
                          </span>
                        )}
                        {container.calculatedETA?.journeyStage && (
                          <span className="text-muted-foreground">
                            {' '}
                            · {container.calculatedETA.journeyStage}
                          </span>
                        )}
                      </SummaryRow>
                    )}
                    <SummaryRow label="Port date">
                      {fmtDate(container.portDate)}
                    </SummaryRow>
                  </dl>
                </CardHeader>
                <CardBody className="mb-[60px]">
                  <div className="table-responsive">
                    <table className="table table-centered table-nowrap">
                      <thead className="thead-light">
                        <tr>
                          <th></th>
                          <th>SKU</th>
                          <th>Name</th>
                          <th>Quantity</th>
                          <th>Cost Per Item</th>
                          <th>Volumes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {container.containerLines.map((containerLine) => {
                          volumes[containerLine.variant.sku] = {
                            size:
                              Math.round(
                                (containerLine?.variant?.product?.width *
                                  containerLine?.variant?.product?.length *
                                  containerLine?.variant?.product?.depth) /
                                  1000
                              ) / 1000,
                            quantity: containerLine.quantity,
                          };

                          return (
                            <tr className="py-5">
                              <td className="text-right">
                                <div
                                  style={{
                                    width: '128px',
                                    height: '128px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <img
                                    src={
                                      getVariant(containerLine.variant.sku)
                                        ?.image
                                    }
                                    alt=""
                                    className="img-fluid"
                                  />
                                </div>
                              </td>
                              <td className="">{containerLine.variant.sku}</td>
                              <td className="">{containerLine.variant.name}</td>
                              <td className="">{containerLine.quantity}</td>
                              <td className="">
                                {containerLine.costPerItem}
                              </td>
                              <td>
                                {Math.round(
                                  (containerLine?.variant?.product?.width *
                                    containerLine?.variant?.product?.length *
                                    containerLine?.variant?.product?.depth) /
                                    1000
                                ) / 1000}
                              </td>
                            </tr>
                          );
                        })}

                        <tr className="py-5">
                          <td className="text-right"> TOTAL </td>
                          <td className=""></td>
                          <td className=""></td>
                          <td className="">
                            {container.containerLines.reduce(
                              (sum, containerLine) =>
                                sum + containerLine.quantity,
                              0
                            )}
                          </td>
                          <td className="">
                            {Math.round(
                              container.containerLines.reduce(
                                (sum, containerLine) =>
                                  sum +
                                containerLine.costPerItem *
                                containerLine.quantity,
                                0
                              ) * 100
                            ) / 100}
                          </td>
                          <td>
                            { Math.round(Object.values(volumes)?.reduce(
                              (sum, volume) =>
                                sum + volume.size * volume.quantity
                                , 0
                            )*1000) / 1000
                          }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                
                </CardBody>
              </>
            )}
          </Card>

          {container && (
            <Card className="mb-10">
              <CardHeader>
                <h4 className="text-[18px] font-medium">Timeline</h4>
              </CardHeader>
              <CardBody>
                <ContainerTimelineView containerId={containerID} />
              </CardBody>
            </Card>
          )}
        </Col>
      </div>
    </SupplyChainNav>
  );
};

export default PullPage;
